module.exports = __webpack_public_path__ + "static/media/xiangshan_mobile.72b59e54.png";